import React, { useEffect, useState } from "react";
import Nav from "../../master/NavBar";
import Header from "../../master/SideBar";
import { Link } from "react-router-dom";
import { ToastMain, SweetAlertShow, LoadingDiv } from "../../master/Master";
import { getBatchList } from "../../../api/BatchService";
import { feesfollowup } from "../../../api/FeesDeposite";
import { courseList } from "../../../api/Courses";
import DownloadExcel from "../../master/DownloadExcel";
import Swal from "sweetalert2";
import {
  AssignData,
  GetMarketingData,
  GetMarketingSchool,
} from "../../../api/MarketinService";
import { counselor } from "../../../api/Calling";
import MarketingHeader from "../Marketings/MarketingHeader";
import { DistrictFetch, StateFetch } from "../../../api/LocationService";

const Assgin = () => {
  const [data, setdata] = useState([]);
  const [status, setStatus] = useState("");
  const [enquiry, setEnquiry] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [showBatch, setShowBatch] = useState(false);
  const [Batches, setBatches] = useState([]);
  const [page, setPage] = useState(1);
  const [selectedSource, setSelectedSource] = useState("marketing");
  const [selectedCounselor, setSelectedCounselor] = useState("");
  const [sources, setSource] = useState([]);
  const [course, setCourse] = useState([]);
  const [SourceData, setSourceData] = useState([]);
  const [counse, setcounse] = useState([]);
  const [course_id, setCourseId] = useState("");
  const [session_id, setSessionId] = useState("");
  const [selectedType, setSelectedType] = useState("marketing");
  const [SelectedCourseId, setSelectedCourseId] = useState("");
  const [SelectedBatchId, setSelectedBatchId] = useState("");
  const [SelectedSourceId, setSelectedSourceId] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedCourseIds, setSelectedCourseIds] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const districts = ["jaipur", "sikar", "jhodpur", "Chomu", "Kolkata", "Pune"];

  const [allDistricts, setAllDistricts] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");

  const userData = JSON.parse(localStorage.getItem("user_data"));
  const userId = userData?.id;
  const userType = userData?.staff?.type_id;

  const courseFetch = async () => {
    setLoading(true);
    try {
      const response = await courseList();
      if (response.data.status) {
        setCourse(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getState = async () => {
    setLoading(true);
    try {
      const response = await StateFetch();
      if (response.data) {
        setAllStates(response?.data?.states);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedState) {
      getdistrict(selectedState);
      setSelectedDistrict("");
    }
  }, [selectedState]);

  const getdistrict = async (state) => {
    if (!state) return;

    setLoading(true);
    try {
      const response = await DistrictFetch(state);
      if (response?.data?.districts) {
        setAllDistricts(response.data.districts);
      } else {
        setAllDistricts([]);
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "No districts found",
        );
      }
    } catch (err) {
      setAllDistricts([]);
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const batchList = async () => {
    setLoading(true);
    try {
      const response = await getBatchList();
      if (response.data.status) {
        setBatches(response?.data?.batches || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    let searchInput = e.target.search.value;
    if (searchInput) setSearch(searchInput);
  };

  const getSource = async () => {
    try {
      const response = await GetMarketingSchool();
      if (response?.data) {
        setSource(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    }
  };

  const handleCourseChange = (e) => {
    const options = e.target.options;
    const selected = [];

    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selected.push(options[i].value);
      }
    }

    setSelectedCourseIds(selected);
  };

  const DataAssing = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();

    formData.append("type", selectedSource);
    formData.append("counselor_id", selectedCounselor);
    formData.append("source_id", SelectedSourceId);
    formData.append("district", selectedDistrict);

    const stringIds = selectedStudents.map((id) => id.toString());

    formData.append("student_ids", JSON.stringify(stringIds));

    try {
      const response = await AssignData(formData);

      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: "Assigned successfully!",
        }).then(() => {
          getMarketingData();
        });
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getMarketingData = async () => {
    setLoading(true);

    let addUrl = `&type=${selectedType}&course_id=${selectedCourseIds}&batch_id=${SelectedBatchId}&source_id=${SelectedSourceId}`;

    try {
      const response = await GetMarketingData(addUrl);

      console.log("resposne", response);

      if (response?.data) {
        setSourceData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedType) {
      getMarketingData();
    }
  }, [selectedType, selectedCourseIds, SelectedBatchId, SelectedSourceId]);

  const getcounselor = async () => {
    setLoading(true);

    try {
      const response = await counselor();

      if (response?.data) {
        setcounse(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getcounselor();
    getSource();
    batchList();
    courseFetch();
    getdistrict();
    getState();
  }, []);

  useEffect(() => {
    if (
      SourceData?.data?.length > 0 &&
      selectedStudents.length === SourceData.data.length
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedStudents, SourceData]);

  useEffect(() => {
    setSelectedStudents([]);
    setSelectAll(false);
  }, [SourceData]);

  const handleDownload = () => {
    const exportData = enquiry?.data || [];

    if (exportData.length === 0) {
      alert("No data available to export");
      return;
    }

    DownloadExcel(
      exportData,
      ["SN", "Student Name", "response", "followup_date"],
      "Enquiry List",
      [
        {
          type: "rename",
          oldKey: "student_name",
          newKey: "Student Name",
        },
        {
          type: "rename",
          oldKey: "father_name",
          newKey: "Father Name",
        },
        {
          type: "add",
          newKey: "Time",
          value: "00:00:00",
        },
      ],
    );
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;

    setSelectAll(isChecked);

    if (isChecked) {
      const allIds = SourceData?.data?.map((item) => item.id) || [];

      setSelectedStudents(allIds);
    } else {
      setSelectedStudents([]);
    }
  };

  const handleStudentSelect = (item, e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setSelectedStudents((prev) => [...prev, item.id]);
    } else {
      setSelectedStudents((prev) => prev.filter((id) => id !== item.id));
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="container-fluid py-3">
              <div className="row g-4">
                {/* Marketing Header */}
                <div className="col-12">
                  <MarketingHeader />
                </div>

                {/* Page Header + Filters */}
                <div className="col-12">
                  <div className="card border-0 shadow-sm overflow-hidden">
                    {/* Header */}
                    <div className="card-header bg-transparent border-bottom py-3 px-4">
                      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="rounded-3 d-flex align-items-center justify-content-center bg-primary text-white"
                            style={{
                              width: "46px",
                              height: "46px",
                              flexShrink: 0,
                            }}
                          >
                            <i className="ri-user-settings-line fs-4"></i>
                          </div>

                          <div>
                            <h4 className="mb-1 fw-bold">Allocate Data</h4>

                            <p className="mb-0 text-muted small">
                              Assign marketing, enquiry and fee records to
                              counselors
                            </p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                          <span className="badge bg-primary text-white px-3 py-2 rounded-pill">
                            <i className="ri-database-2-line me-1"></i>
                            {SourceData?.data?.length || 0} Records
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Filter Body */}
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center gap-2 mb-4">
                        <div className="text-primary">
                          <i className="ri-filter-3-line fs-5"></i>
                        </div>

                        <div>
                          <h6 className="mb-0 fw-bold">Allocation Filters</h6>

                          <small className="text-muted">
                            Select counselor and narrow down the records
                          </small>
                        </div>
                      </div>

                      <div className="row g-3">
                        {/* Counselor */}
                        <div className="col-xl-3 col-lg-4 col-md-6">
                          <div className="form-floating form-floating-outline">
                            <select
                              name="counselor_id"
                              className="form-select"
                              value={selectedCounselor}
                              onChange={(e) =>
                                setSelectedCounselor(e.target.value)
                              }
                              defaultValue=""
                            >
                              <option value="" disabled>
                                -- Select Counselor --
                              </option>

                              {counse?.data
                                ?.filter((counselor) => {
                                  if (
                                    counselor?.user?.id === userId &&
                                    counselor?.type_id === userType
                                  )
                                    return true;

                                  const hasMatch = counse?.data?.some(
                                    (c) =>
                                      c?.user?.id === userId &&
                                      c?.type_id === userType,
                                  );

                                  return !hasMatch;
                                })
                                ?.map((counselor, index) => (
                                  <option key={index} value={counselor.id}>
                                    {counselor.name}
                                  </option>
                                ))}
                            </select>

                            <label>
                              <i className="ri-user-line me-1"></i>
                              Select Counselor
                            </label>
                          </div>
                        </div>

                        {selectedCounselor && (
                          <>
                            {/* State */}
                            <div className="col-xl-3 col-lg-4 col-md-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  name="state"
                                  className="form-select"
                                  value={selectedState}
                                  onChange={(e) =>
                                    setSelectedState(e.target.value)
                                  }
                                >
                                  <option value="" disabled>
                                    -- Select State --
                                  </option>

                                  {allStates?.map((state) => (
                                    <option key={state.id} value={state.name}>
                                      {state.name}
                                    </option>
                                  ))}
                                </select>

                                <label>
                                  <i className="ri-map-pin-line me-1"></i>
                                  Select State
                                </label>
                              </div>
                            </div>

                            {/* District */}
                            {selectedState && (
                              <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="district"
                                    className="form-select"
                                    value={selectedDistrict}
                                    onChange={(e) =>
                                      setSelectedDistrict(e.target.value)
                                    }
                                  >
                                    <option value="" disabled>
                                      -- Select District --
                                    </option>

                                    {allDistricts?.map((district) => (
                                      <option
                                        key={district.id}
                                        value={district.id}
                                      >
                                        {district.name}
                                      </option>
                                    ))}
                                  </select>

                                  <label>
                                    <i className="ri-road-map-line me-1"></i>
                                    Select District
                                  </label>
                                </div>
                              </div>
                            )}

                            {/* Marketing Source */}
                            {selectedSource === "marketing" && (
                              <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="source_id"
                                    className="form-select"
                                    value={SelectedSourceId}
                                    onChange={(e) =>
                                      setSelectedSourceId(e.target.value)
                                    }
                                    defaultValue=""
                                  >
                                    <option value="" disabled>
                                      Select Source
                                    </option>

                                    {sources?.data?.map((source, index) => (
                                      <option key={index} value={source.id}>
                                        {source.source_name}
                                      </option>
                                    ))}
                                  </select>

                                  <label>
                                    <i className="ri-megaphone-line me-1"></i>
                                    Source Name
                                  </label>
                                </div>
                              </div>
                            )}

                            {/* Course */}
                            {selectedSource === "enquiry" && (
                              <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="course_id"
                                    className="form-select"
                                    multiple
                                    value={selectedCourseIds}
                                    onChange={handleCourseChange}
                                    style={{
                                      height: "5rem",
                                    }}
                                  >
                                    <option value="" disabled>
                                      Select Course
                                    </option>

                                    {course?.data?.map((c, index) => (
                                      <option key={index} value={c.id}>
                                        {c.title}
                                      </option>
                                    ))}
                                  </select>

                                  <label>
                                    <i className="ri-book-open-line me-1"></i>
                                    Select Course
                                  </label>
                                </div>
                              </div>
                            )}

                            {/* Batch */}
                            {selectedSource === "fees" && (
                              <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="Batch_id"
                                    className="form-select"
                                    value={SelectedBatchId}
                                    onChange={(e) =>
                                      setSelectedBatchId(e.target.value)
                                    }
                                    defaultValue=""
                                    multiple
                                  >
                                    <option value="" disabled>
                                      Select Batch
                                    </option>

                                    {Batches?.map((b, index) => (
                                      <option key={index} value={b.id}>
                                        {b.title}
                                      </option>
                                    ))}
                                  </select>

                                  <label>
                                    <i className="ri-stack-line me-1"></i>
                                    Select Batch
                                  </label>
                                </div>
                              </div>
                            )}

                            {/* Search */}
                            <div className="col-xl-3 col-lg-4 col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search by Name, Mobile"
                                  name="search"
                                  onChange={(e) => {
                                    e.target.value =
                                      e.target.value.toUpperCase();
                                  }}
                                />

                                <label>
                                  <i className="ri-search-line me-1"></i>
                                  Search by Name, Mobile
                                </label>
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                      {/* Active Filter Summary */}
                      {selectedCounselor && (
                        <div className="mt-4 pt-3 border-top">
                          <div className="d-flex flex-wrap align-items-center gap-2">
                            <span className="text-muted small fw-semibold me-1">
                              <i className="ri-filter-line me-1"></i>
                              Active:
                            </span>

                            <span className="badge rounded-pill bg-primary text-white px-3 py-2">
                              <i className="ri-user-line me-1"></i>
                              Counselor selected
                            </span>

                            {selectedState && (
                              <span className="badge rounded-pill bg-info bg-opacity-10 text-info px-3 py-2">
                                <i className="ri-map-pin-line me-1"></i>
                                {selectedState}
                              </span>
                            )}

                            {selectedDistrict && (
                              <span className="badge rounded-pill bg-success bg-opacity-10 text-success px-3 py-2">
                                <i className="ri-road-map-line me-1"></i>
                                District selected
                              </span>
                            )}

                            {SelectedSourceId && (
                              <span className="badge rounded-pill bg-warning bg-opacity-10 text-warning px-3 py-2">
                                <i className="ri-megaphone-line me-1"></i>
                                Source selected
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Data Table */}
                {selectedSource && (
                  <div className="col-12">
                    <div className="card border-0 shadow-sm overflow-hidden">
                      {/* Table Header */}
                      <div className="card-header bg-transparent border-bottom py-3 px-4">
                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                          <div className="d-flex align-items-center gap-3">
                            <div
                              className="rounded-3 d-flex align-items-center justify-content-center bg-success bg-opacity-10 text-success"
                              style={{
                                width: "44px",
                                height: "44px",
                                flexShrink: 0,
                              }}
                            >
                              <i className="ri-list-check-2 fs-5"></i>
                            </div>

                            <div>
                              <h5 className="mb-1 fw-bold">
                                Available Records
                              </h5>

                              <p className="mb-0 text-muted small">
                                Select students you want to assign
                              </p>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <span className="badge rounded-pill bg-secondary bg-opacity-10 text-secondary px-3 py-2">
                              {SourceData?.data?.length || 0} Total
                            </span>

                            {selectedStudents.length > 0 && (
                              <span className="badge rounded-pill bg-primary px-3 py-2">
                                {selectedStudents.length} Selected
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Assignment Bar */}
                      {selectedStudents.length > 0 && (
                        <div className="px-4 pt-4">
                          <div className="border rounded-3 p-3 bg-primary bg-opacity-10">
                            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                              <div className="d-flex align-items-center gap-3">
                                <div
                                  className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    flexShrink: 0,
                                  }}
                                >
                                  <i className="ri-user-follow-line"></i>
                                </div>

                                <div>
                                  <div className="fw-bold text-primary">
                                    {selectedStudents.length} student
                                    {selectedStudents.length > 1
                                      ? "s"
                                      : ""}{" "}
                                    selected
                                  </div>

                                  <small className="text-muted">
                                    Ready to assign selected records
                                  </small>
                                </div>
                              </div>

                              <button
                                type="button"
                                className="btn btn-primary px-4"
                                onClick={DataAssing}
                              >
                                <i className="ri-user-shared-line me-2"></i>
                                Assign Data
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Table */}
                      <div className="card-body p-0">
                        <div
                          className="table-responsive"
                          style={{
                            maxHeight: "calc(100vh - 390px)",
                            minHeight: "300px",
                          }}
                        >
                          <table className="table table-hover align-middle mb-0">
                            {/* ENQUIRY HEADER */}
                            {selectedSource === "enquiry" && (
                              <thead className="table-primary sticky-top">
                                <tr>
                                  <th className="ps-4 text-nowrap">#</th>
                                  <th className="text-nowrap">
                                    <i className="ri-user-line me-1"></i>
                                    Name
                                  </th>
                                  <th className="text-nowrap">Father Name</th>
                                  <th className="text-nowrap">
                                    <i className="ri-phone-line me-1"></i>
                                    Mobile
                                  </th>
                                  <th className="text-nowrap">Address</th>
                                  <th className="text-nowrap">Course</th>
                                  <th className="text-nowrap">Status</th>
                                  <th className="text-nowrap">Date</th>
                                  <th className="text-center text-nowrap pe-4">
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                      <input
                                        type="checkbox"
                                        className="form-check-input mt-0"
                                        checked={selectAll}
                                        onChange={handleSelectAll}
                                      />
                                      <span>All Select</span>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                            )}

                            {/* FEES HEADER */}
                            {selectedSource === "fees" && (
                              <thead className="table-primary sticky-top">
                                <tr>
                                  <th className="ps-4 text-nowrap">#</th>
                                  <th className="text-nowrap">
                                    <i className="ri-user-line me-1"></i>
                                    Name
                                  </th>
                                  <th className="text-nowrap">Father Name</th>
                                  <th className="text-nowrap">
                                    <i className="ri-phone-line me-1"></i>
                                    Mobile
                                  </th>
                                  <th className="text-nowrap">Address</th>
                                  <th className="text-nowrap">Course</th>
                                  <th className="text-nowrap">Batch</th>
                                  <th className="text-nowrap">Date</th>
                                  <th className="text-center text-nowrap pe-4">
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                      <input
                                        type="checkbox"
                                        className="form-check-input mt-0"
                                        checked={selectAll}
                                        onChange={handleSelectAll}
                                      />
                                      <span>All Select</span>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                            )}

                            {/* MARKETING HEADER */}
                            {selectedSource === "marketing" && (
                              <thead className="table-primary sticky-top">
                                <tr>
                                  <th className="ps-4 text-nowrap">#</th>
                                  <th className="text-nowrap">
                                    <i className="ri-user-line me-1"></i>
                                    Name
                                  </th>
                                  <th className="text-nowrap">Father Name</th>
                                  <th className="text-nowrap">
                                    <i className="ri-phone-line me-1"></i>
                                    Mobile
                                  </th>
                                  <th className="text-nowrap">Source Name</th>
                                  <th className="text-nowrap">Address</th>
                                  <th className="text-nowrap">Date</th>
                                  <th className="text-center text-nowrap pe-4">
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                      <input
                                        type="checkbox"
                                        className="form-check-input mt-0"
                                        checked={selectAll}
                                        onChange={handleSelectAll}
                                      />
                                      <span>All Select</span>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                            )}

                            {/* ENQUIRY DATA */}
                            {selectedSource === "enquiry" && (
                              <tbody className="text-capitalize">
                                {SourceData?.data?.length === 0 ? (
                                  <tr>
                                    <td colSpan="10">
                                      <div className="py-5 text-center">
                                        <div
                                          className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center bg-secondary bg-opacity-10 text-secondary"
                                          style={{
                                            width: "60px",
                                            height: "60px",
                                          }}
                                        >
                                          <i className="ri-inbox-line fs-3"></i>
                                        </div>

                                        <h6 className="fw-bold mb-1">
                                          No Data Found
                                        </h6>

                                        <p className="text-muted small mb-0">
                                          No enquiry records are available for
                                          the selected filters.
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                ) : (
                                  SourceData?.data?.map((item, i) => (
                                    <tr key={item.id}>
                                      <td className="ps-4 fw-semibold text-muted">
                                        {i + 1 || "N/A"}
                                      </td>

                                      <td>
                                        <div className="fw-semibold">
                                          {item.student_name || "N/A"}
                                        </div>
                                      </td>

                                      <td>{item.father_name || "N/A"}</td>

                                      <td className="text-nowrap">
                                        {item?.mobile || "N/A"}
                                      </td>

                                      <td>
                                        <span className="text-muted">
                                          {item.village || "N/A"}
                                        </span>
                                      </td>

                                      <td>
                                        <span className="badge bg-info bg-opacity-10 text-info rounded-pill px-3 py-2">
                                          {item?.course?.title || "N/A"}
                                        </span>
                                      </td>

                                      <td>
                                        <span className="badge bg-warning bg-opacity-10 text-warning rounded-pill px-3 py-2">
                                          {item?.status || "N/A"}
                                        </span>
                                      </td>

                                      <td className="text-nowrap">
                                        {item?.enquiry_date || "N/A"}
                                      </td>

                                      <td className="text-center pe-4">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={selectedStudents.includes(
                                            item.id,
                                          )}
                                          onChange={(e) =>
                                            handleStudentSelect(item, e)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            )}

                            {/* FEES DATA */}
                            {selectedSource === "fees" && (
                              <tbody className="text-capitalize">
                                {SourceData?.data?.length === 0 ? (
                                  <tr>
                                    <td colSpan="10">
                                      <div className="py-5 text-center">
                                        <div
                                          className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center bg-secondary bg-opacity-10 text-secondary"
                                          style={{
                                            width: "60px",
                                            height: "60px",
                                          }}
                                        >
                                          <i className="ri-inbox-line fs-3"></i>
                                        </div>

                                        <h6 className="fw-bold mb-1">
                                          No Data Found
                                        </h6>

                                        <p className="text-muted small mb-0">
                                          No fee records are available for the
                                          selected filters.
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                ) : (
                                  SourceData?.data?.map((item, i) => (
                                    <tr key={item.id}>
                                      <td className="ps-4 fw-semibold text-muted">
                                        {i + 1 || "N/A"}
                                      </td>

                                      <td>
                                        <div className="fw-semibold">
                                          {item?.student_info?.name || "N/A"}
                                        </div>
                                      </td>

                                      <td>
                                        {item?.student_info?.father_name ||
                                          "N/A"}
                                      </td>

                                      <td className="text-nowrap">
                                        {item?.student_info?.phone || "N/A"}
                                      </td>

                                      <td>
                                        <span className="text-muted">
                                          {item?.student_info?.village || "N/A"}
                                        </span>
                                      </td>

                                      <td>
                                        <span className="badge bg-info bg-opacity-10 text-info rounded-pill px-3 py-2">
                                          {item?.course?.title || "N/A"}
                                        </span>
                                      </td>

                                      <td>
                                        <span className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-3 py-2">
                                          {item?.batch?.title || "N/A"}
                                        </span>
                                      </td>

                                      <td className="text-nowrap">
                                        {item?.student_info?.admission_date ||
                                          "N/A"}
                                      </td>

                                      <td className="text-center pe-4">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={selectedStudents.includes(
                                            item.id,
                                          )}
                                          onChange={(e) =>
                                            handleStudentSelect(item, e)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            )}

                            {/* MARKETING DATA */}
                            {selectedSource === "marketing" && (
                              <tbody className="text-capitalize">
                                {SourceData?.data?.length === 0 ? (
                                  <tr>
                                    <td colSpan="10">
                                      <div className="py-5 text-center">
                                        <div
                                          className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center bg-secondary bg-opacity-10 text-secondary"
                                          style={{
                                            width: "60px",
                                            height: "60px",
                                          }}
                                        >
                                          <i className="ri-inbox-line fs-3"></i>
                                        </div>

                                        <h6 className="fw-bold mb-1">
                                          No Source Found
                                        </h6>

                                        <p className="text-muted small mb-0">
                                          No marketing records are available for
                                          the selected filters.
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                ) : (
                                  SourceData?.data?.map((item, i) => (
                                    <tr key={item.id}>
                                      <td className="ps-4 fw-semibold text-muted">
                                        {i + 1 || "N/A"}
                                      </td>

                                      <td>
                                        <div className="fw-semibold">
                                          {item?.name || "N/A"}
                                        </div>
                                      </td>

                                      <td>{item?.fathers_name || "N/A"}</td>

                                      <td className="text-nowrap">
                                        {item?.mobile || "N/A"}
                                      </td>

                                      <td>
                                        <span className="badge bg-warning bg-opacity-10 text-warning rounded-pill px-3 py-2">
                                          {item?.source?.source_name || "N/A"}
                                        </span>
                                      </td>

                                      <td>
                                        <span className="text-muted">
                                          {item?.village || "N/A"}
                                        </span>
                                      </td>

                                      <td className="text-nowrap">
                                        {new Date(
                                          item?.created_at,
                                        ).toLocaleDateString("en-IN", {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                        }) || "N/A"}
                                      </td>

                                      <td className="text-center pe-4">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={selectedStudents.includes(
                                            item.id,
                                          )}
                                          onChange={(e) =>
                                            handleStudentSelect(item, e)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            )}
                          </table>
                        </div>
                      </div>

                      {/* Bottom Summary */}
                      {SourceData?.data?.length > 0 && (
                        <div className="card-footer bg-transparent border-top px-4 py-3">
                          <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                            <div className="text-muted small">
                              <i className="ri-information-line me-1"></i>
                              Showing{" "}
                              <strong className="text-body">
                                {SourceData?.data?.length}
                              </strong>{" "}
                              records
                            </div>

                            <div className="text-muted small">
                              <i className="ri-checkbox-multiple-line me-1"></i>
                              <strong className="text-body">
                                {selectedStudents.length}
                              </strong>{" "}
                              selected
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Assgin;
